import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import styles from './HeadBand.module.css';
const HeadBandContext = createContext({});
export const HeadBand = ({ useTailwindPrefix, position = 'top', isVisible, onClose, children, className, containerClassName, }) => {
    const [visible, setVisible] = useState(isVisible);
    const sidebarRef = useRef(null);
    const containerRef = useRef(null);
    const didMountRef = useRef(false);
    useEffect(() => {
        var _a;
        if (isVisible) {
            setTimeout(() => {
                setVisible(true);
            }, 100);
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'block');
            didMountRef.current = true;
        }
        else if (didMountRef.current && !isVisible) {
            setVisible(false);
            setTimeout(() => {
                var _a;
                (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('display', 'none');
            }, 300);
        }
    }, [isVisible]);
    return (_jsx(_Fragment, { children: _jsx(HeadBandContext.Provider, Object.assign({ value: { useTailwindPrefix, onClose } }, { children: _jsx("div", Object.assign({ className: classNames(containerClassName, {
                    'fixed left-0 right-0 w-full cursor-pointer hidden': !useTailwindPrefix,
                    'tw-fixed tw-left-0 tw-right-0 tw-w-full tw-cursor-pointer tw-hidden': useTailwindPrefix,
                    'top-0': position === 'top' && !useTailwindPrefix,
                    'tw-top-0': position === 'top' && useTailwindPrefix,
                    'bottom-0': position === 'bottom' && !useTailwindPrefix,
                    'tw-bottom-0': position === 'bottom' && useTailwindPrefix,
                }), ref: containerRef }, { children: _jsx("div", Object.assign({ className: classNames(className, {
                        'w-full border-gray-200 transition cursor-auto ease-in relative': !useTailwindPrefix,
                        'tw-w-full tw-border-gray-200 tw-transition tw-cursor-auto tw-ease-in tw-relative': useTailwindPrefix,
                        'translate-y-0 opacity-100': visible && !useTailwindPrefix,
                        'tw-translate-y-0 tw-opacity-100': visible && useTailwindPrefix,
                        '-translate-y-full opacity-0': !visible && position === 'top' && !useTailwindPrefix,
                        'tw--translate-y-full tw-opacity-0': !visible && position === 'top' && useTailwindPrefix,
                        'translate-y-full opacity-0': !visible && position === 'bottom' && !useTailwindPrefix,
                        'tw-translate-y-full tw-opacity-0': !visible && position === 'bottom' && useTailwindPrefix,
                        'border-t-[0.2px]': position === 'top',
                        'tw-border-t-[0.2px]': position === 'top',
                        'border-b-[0.2px]': position === 'bottom',
                        'tw-border-b-[0.2px]': position === 'bottom',
                        [styles['top-shadow']]: position === 'bottom',
                        [styles['bottom-shadow']]: position === 'top',
                    }), ref: sidebarRef }, { children: children })) })) })) }));
};
const Container = ({ children }) => {
    const { useTailwindPrefix } = useContext(HeadBandContext);
    return (_jsx("div", Object.assign({ className: classNames(styles.container, {
            'relative mx-auto p-4': !useTailwindPrefix,
            'tw-relative tw-mx-auto tw-p-4': useTailwindPrefix,
        }) }, { children: children })));
};
const CloseButton = ({ className }) => {
    const { useTailwindPrefix, onClose } = useContext(HeadBandContext);
    function onCloseEvent() {
        if (onClose) {
            onClose();
        }
    }
    return (_jsx("div", Object.assign({ className: classNames(className, {
            'absolute top-0 right-0 z-10 w-7 h-7 rounded-full flex items-center justify-center transition cursor-pointer': !useTailwindPrefix,
            'tw-absolute tw-top-0 tw-right-0 tw-z-10 tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition tw-cursor-pointer': useTailwindPrefix,
        }), onClick: onCloseEvent }, { children: _jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", className: classNames({ 'h-5 w-5': !useTailwindPrefix, 'tw-h-5 tw-w-5': useTailwindPrefix }), fill: "currentColor" }, { children: _jsx("path", { d: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" }) })) })));
};
HeadBand.Container = Container;
HeadBand.CloseButton = CloseButton;
export default HeadBand;
